import React from 'react';
import { useTranslation } from "react-i18next";

export default function QuienesSomos()
{
    const { t } = useTranslation();
    return(
        <section className="page-section" id="quienessomos">
            <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0" style={{margin:'20px'}}>{t('nav_menu1')}</h2>
                <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-white" style={{margin:'20px'}}>Toolsoft Interactive</h2>
                <div className="row">
                    <h3 className="text-center">{t('about_title1')}</h3>
                    <p className="text-center">{t('about_text1')}</p>
                    <h3 className="text-center">{t('about_title2')}</h3>
                    <p className="text-center">{t('about_text2')}</p>
                    <h3 className="text-center">{t('about_title3')}</h3>
                    <ul className="listText">
                        <li className="text-center">{t('about_ul_li1')}</li>
                        <li className="text-center">{t('about_ul_li2')}</li>
                        <li className="text-center">{t('about_ul_li3')}</li>
                        <li className="text-center">{t('about_ul_li4')}</li>
                    </ul>
                </div>
            </div>
            </div>
        </section>
    )
}